export default "__VITE_ASSET__e4881cb3__"